// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Radio from 'common/domain/radio';
import PageMessage from 'common/components/PageMessage';
import { getCurrentRadio } from 'statsradio/modules/authentication/session/selectors/sessionSelectors';

export const ANOMALIES_MESSAGE_ID = 'anomalies-message';

type Props = {
  radio: Radio | void;
  t: (key: string) => any;
};

export function AnomaliesBanner({ radio, t }: Props): React.Node {
  if (!radio || !radio.hasAnomalies) {
    return null;
  }

  return (
    <PageMessage
      id={ANOMALIES_MESSAGE_ID}
      type="important"
      message={t('radioHasAnomaliesMessage')}
    />
  );
}

function mapStateToProps(state) {
  return {
    radio: getCurrentRadio(state),
  };
}

export default translate('radio')(connect(mapStateToProps)(AnomaliesBanner));




// WEBPACK FOOTER //
// ./src/statsradio/modules/radio/components/AnomaliesBanner.js